import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useTranslation } from "react-i18next";

import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Chat from "@/pages/Chat";
import Studio from "@/pages/Studio";
import Contracts from "@/pages/Contracts";
import Coran from "@/pages/Coran";
import About from "@/pages/About";
import Music from "@/pages/Music";
import Reseaux from "@/pages/Reseaux";
import Portrait from "@/pages/Portrait";
import Live from "@/pages/Live";
import Evoto from "@/pages/Evoto";
import Decode from "@/pages/Decode";
import Analyse from "@/pages/Analyse";
import FacebookPage from "@/pages/FacebookPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Services from "@/pages/Services";
import GP from "@/pages/GP";
import Transfer from "@/pages/Transfer";
import TransferStatus from "@/pages/TransferStatus";
import Dropship from "@/pages/Dropship";
import DropshipStatus from "@/pages/DropshipStatus";
import Admin from "@/pages/Admin";
import MyTransfers from "@/pages/MyTransfers";
import Retouche from "@/pages/Retouche";
import RetoucheStatus from "@/pages/RetoucheStatus";
import NihmaTV from "@/pages/NihmaTV";
import Verset from "@/pages/Verset";
import Ramadan from "@/pages/Ramadan";
import VoiceGift from "@/pages/VoiceGift";
import DevisExpress from "@/pages/DevisExpress";

export default function App() {
  // Abonnement à la langue : re-rendu de toutes les pages au changement FR/EN/AR/WO
  useTranslation();
  return (
    <>
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <ErrorBoundary>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Landing />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/contrats" element={<Contracts />} />
              <Route path="/coran" element={<Coran />} />
              <Route path="/nihma-tv" element={<NihmaTV />} />
              <Route path="/verset" element={<Verset />} />
              <Route path="/ramadan" element={<Ramadan />} />
              <Route path="/voice-gift" element={<VoiceGift />} />
              <Route path="/devis-express" element={<DevisExpress />} />
              <Route path="/reseaux" element={<Reseaux />} />
              <Route path="/portrait" element={<Portrait />} />
              <Route path="/live" element={<Live />} />
              <Route path="/evoto" element={<Evoto />} />
              <Route path="/decoder" element={<Decode />} />
              <Route path="/analyse" element={<Analyse />} />
              <Route path="/facebook" element={<FacebookPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gp" element={<GP />} />
              <Route path="/transfer" element={<Transfer />} />
              <Route path="/transfer/success" element={<TransferStatus kind="success" />} />
              <Route path="/transfer/cancel" element={<TransferStatus kind="cancel" />} />
              <Route path="/dropship" element={<Dropship />} />
              <Route path="/dropship/success" element={<DropshipStatus kind="success" />} />
              <Route path="/dropship/cancel" element={<DropshipStatus kind="cancel" />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/me/transferts" element={<MyTransfers />} />
              <Route path="/retouche" element={<Retouche />} />
              <Route path="/retouche/success" element={<RetoucheStatus kind="success" />} />
              <Route path="/retouche/cancel" element={<RetoucheStatus kind="cancel" />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/cgu" element={<Terms />} />
              <Route path="/papicoo" element={<About />} />
              <Route path="/musique" element={<Music />} />
            </Route>
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </>
  );
}
